<template>
  <div class="card country-detail-card">
    <div class="card-content" :class="{ 'country-content': flagCode }">
      <div class="country-detail-card">
        <div class="label country-detail-card-header">
          <country-flag v-if="flagCode" :country="flagCode" size="normal" />
          <br />
          <span class="country-name" v-if="contentHeaderData == 'paper'"
            >Paper (Non-Packaging)</span
          >
          <span class="country-name" v-else-if="contentHeaderData == 'sup'"
            >SUP (Single Use Plastic)</span
          >
          <span class="country-name" v-else>{{ contentHeaderData }}</span>
        </div>
      </div>
      <div class="content">
        <compliance-pie-chart
          :fees="pieChartFees"
          :labels="pieChartLabel"
          :height="height"
          :currency="currency"
          :position="'bottom'"
          :isNAvalue="isNAvalue"
        ></compliance-pie-chart>
      </div>
      <div class="content compliance-content" v-if="contentData">
        <div class="weight-by-fee">
          <p>
            {{
              totalWeight
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
            Kg /
            {{
              isNAvalue && totalFee == 0
                ? "NA"
                : parseFloat(totalFee)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
            {{ isNAvalue && totalFee == 0 ? "" : currency }}
          </p>
        </div>
        <div
          class="columns"
          v-for="(value, index) in Object.fromEntries(
            Object.entries(contentData).slice(0, 3)
          )"
          :key="index"
        >
          <div class="column is-6 content-name" v-if="headerText == 'country'">
            <span v-if="headerText == 'country' || headerText == 'scheme'">{{
              index
            }}</span>
            <span v-else>{{ value.name }}</span>
            <span class="weight" v-if="headerText == 'country'"
              >{{
                value.weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              Kg</span
            ><span class="weight" v-else
              >{{
                value.sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              units /
              {{
                value.weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              Kg</span
            >
          </div>
          <div class="column is-8 content-name" v-else>
            <span v-if="headerText == 'country' || headerText == 'scheme'">{{
              index
            }}</span>
            <span v-else>{{ value.name }}</span>
            <span class="weight" v-if="headerText == 'country'"
              >{{
                value.weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              Kg</span
            ><span class="weight" v-else
              >{{
                value.sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              units /
              {{
                value.weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              Kg</span
            >
          </div>
          <div class="column fees">
            {{
              value.fee != "NA"
                ? parseFloat(value.fee)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : "NA"
            }}
            <span v-if="value.fee != 'NA'">&nbsp;{{ value.currency }}</span>
          </div>
        </div>
      </div>
      <div
        class="content below-link"
        v-if="headerText == 'country' && Object.keys(contentData).length > 0"
      >
        <a ref="#" @click.prevent="moreDetails"><p>more details</p></a>
      </div>
      <div
        class="content below-link"
        v-if="headerText == 'scheme' && Object.keys(contentData).length > 0"
      >
        <a ref="#" @click.prevent="moreDetailsScheme"><p>more details</p></a>
      </div>
      <div
        class="content below-link"
        v-if="headerText == 'stream' && Object.keys(contentData).length > 0"
      >
        <a ref="#" @click.prevent="moreDetailsStream(contentHeaderData)"
          ><p>more details</p></a
        >
      </div>
    </div>
  </div>
</template>
<script>
import CompliancePieChart from "./CompliancePieChart.vue";
export default {
  components: { CompliancePieChart },
  name: "CountrySchemeDetailCard",
  props: {
    contentHeaderData: [],
    contentData: [],
    headerText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      flagCode: null,
      pieChartLabel: [],
      pieChartFees: [],
      totalFee: 0,
      totalWeight: 0,
      currency: " ",
      countryId: null,
      schemeId: null,
      height: "",
      isNAvalue: false
    };
  },
  mounted() {
    if (this.headerText == "country" || this.headerText == "scheme") {
      this.totalFee = 0;
      this.totalWeight = 0;
      Object.keys(this.contentData).forEach(key => {
        const value = this.contentData[key];
        this.flagCode = value.country_code;
        if (value.fee != "NA") {
          this.pieChartLabel.push(key);
          this.pieChartFees.push(parseFloat(value.fee));
        }
        if (value.fee == "NA") {
          this.isNAvalue = true;
        }
        this.currency = value.currency;
        this.countryId = value.country_id;
        this.schemeId = value.scheme_id;
        this.totalFee =
          this.totalFee + (value.fee != "NA" ? parseFloat(value.fee) : 0);
        this.totalWeight = this.totalWeight + parseFloat(value.weight);
      });
    } else {
      this.totalFee = 0;
      this.totalWeight = 0;
      Object.keys(this.contentData).forEach(key => {
        const value = this.contentData[key];
        this.pieChartLabel.push(value.name);
        this.pieChartFees.push(value.fee);
        this.currency = value.currency;
        this.totalFee = this.totalFee + value.fee;
        this.totalWeight = this.totalWeight + value.weight;
      });
    }
    if (this.totalFee == 0) {
      this.height = "270";
    } else {
      this.height = "300";
    }
  },
  methods: {
    moreDetails() {
      this.$emit("changeCountryFilter", {
        id: this.countryId,
        name: this.contentHeaderData
      });
    },
    moreDetailsScheme() {
      this.$emit("changeSchemeFilter", {
        id: this.schemeId,
        name: this.contentHeaderData
      });
    },
    moreDetailsStream(value) {
      const routeName = "compliance.stream." + value;
      this.$router.push({ name: routeName }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      //this.$emit("moreDetails", value);
    }
  }
};
</script>
